import './modal-team-challenge.scss';
import Button from '../button/button';
import { useState, useEffect, useCallback } from 'react';
import { Link } from "react-router-dom";
import moment from 'moment';
import ModalTemplate from '../modal-template/modal-template';
import TranslateService from '../../services/translate-service';

export default function ModalTeamChallenge(props) {


    const [POINTS_CORRECT_ANSWER] = useState(10);
    const [counterBack, setCounterBack] = useState('0 minutos 0 segundos');

    const totalPoints = () => {
        return props.round.filter(p => p.esCorrecta).reduce((a, b) => a + b.puntos, 0);
    }

    const totalWrong = () => {
        return props.round.filter(p => !p.esCorrecta).length;
    }

    const totalRight = () => {
        return props.round.filter(p => p.esCorrecta && p.puntos <= POINTS_CORRECT_ANSWER).length;
    }

    const totalQuick = () => {
        return props.round.filter(p => p.esCorrecta && p.puntos > POINTS_CORRECT_ANSWER).length;
    }

    const updateCounterBack = useCallback(
        () => {
            if (!props || !props.status) return;

            let now = moment();
            let dateRound = moment(props.status.fechaSiguienteRonda);
            let diff = 0;

            diff = dateRound.diff(now);

            setCounterBack(`${moment.utc(diff).format("m")} minutos ${moment.utc(diff).format("ss")} segundos `);
        },
        [props, setCounterBack],
    );



    useEffect(() => {
        const interval = setInterval(() => {
            updateCounterBack();
        }, 1000);

        updateCounterBack();
        return () => clearInterval(interval);
    }, [updateCounterBack]);


    useEffect(() => {
        
        return () => {
            document.getElementsByTagName('body')[0].style.overflow =  'auto';
        }
    }, [])

    return (
        <ModalTemplate isOpen={props.isOpen} className="modal-team-challenge">
            {props.round &&
                <>
                    <p className='text-secundary uppercase font-family-montserrat !font-bold text-[12px]'>{TranslateService.get('teamChallenge.modal.over.subtitle')}</p>
                    <h5 className='heading-h5 pt-7'>{TranslateService.get('teamChallenge.modal.over.title')}</h5>
                    <h1 className='heading-h3 !text-heading-card mt-5'>+{totalPoints()} <sup>pts</sup></h1>
                    <p className='text-[12px] text-heading-default'>{TranslateService.get('teamChallenge.modal.over.contribution')}</p>

                    <div className='card'>
                        <div className='flex items-center'>
                            <p className='grow text-secundary text-left '>{TranslateService.get('teamChallenge.modal.over.progress')}</p>
                            <p className='heading-h6 text-right'>{props.status.avance}%</p>
                        </div>
                        <div className='flex items-center mt-2'>
                            <div className='progress'>
                                <div className='progress-bar' style={{ width: `${props.status.avance}%` }}></div>
                            </div>
                        </div>
                        <div className='flex items-center mt-5'>
                            <p className='grow text-secundary text-left '>{TranslateService.get('teamChallenge.modal.over.right')}</p>
                            <p className='text-right'>{totalRight()}</p>
                        </div>
                        <div className='flex items-center separator-bottom pb-5 mt-2'>
                            <p className='grow text-secundary text-left '>{TranslateService.get('teamChallenge.modal.over.quick')}</p>
                            <p className='text-right'>{totalQuick()}</p>
                        </div>
                        <div className='flex items-center mt-5'>
                            <p className='grow text-secundary text-left '>{TranslateService.get('Wrong answers')}</p>
                            <p className='text-right'>{totalWrong()}</p>
                        </div>
                    </div>

                    <p className='text-secundary mt-11'>{TranslateService.get('teamChallenge.modal.over.next')} <span className='!text-heading-card'>{counterBack}</span>.</p>

                    <Link to="/team-challenge">
                        <Button className='mt-7'>
                            {TranslateService.get('teamChallenge.modal.over.btn')}
                        </Button>
                    </Link>
                </>
            }

        </ModalTemplate>
    )
}